import jwtDecode from 'jwt-decode';

export const jwtDecodeSafe = <T>(jwt: string) => {
  try {
    return jwtDecode<T>(jwt);
  } catch {
    return null;
  }
};
